// @ts-nocheck
import { DownloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useState } from "react";
import useContractPdfUrl from "../hooks/apis/useContractPdfUrl";

interface DownloadContractProps {
  uuid: string;
  title: string;
  size?: "middle" | "large" | "small";
  type?: 'primary' | 'default' | 'secondary' | 'outline';
}

const DownloadContract = ({ uuid, title, size = "large", type = "default" }: DownloadContractProps) => {
  const pdfUrlMutation = useContractPdfUrl();
  const [error, setError] = useState<string | null>(null);

  const handleDownload = async () => {
    try {
      setError(null);
      const result = await pdfUrlMutation.trigger(uuid);
      if (result?.url) {
        window.open(result.url, "_blank");
      }
    } catch (err) {
      setError("خطا در دریافت لینک PDF");
      console.error("Error fetching PDF URL:", err);
    }
  };

  return (
    <Button
      type={type}
      size={size}
      icon={<DownloadOutlined />}
      onClick={handleDownload}
      loading={pdfUrlMutation.isMutating}
      disabled={!uuid}
    >
      {title}
    </Button>
  );
};

export default DownloadContract;

